<script lang="ts" setup>
const { $iproKeycloak } = useNuxtApp()

const items = computed(() => [
  [{
    label: $iproKeycloak.tokenParsed?.preferred_username || 'Utilisateur',
    type: 'label' as const,
    slot: 'account' as const,
  }],
  [{
    label: 'Mes informations',
    icon: 'i-lucide-user-pen',
    to: '/mes-informations',
  }],
  [{
    label: 'Déconnexion',
    icon: 'i-lucide-log-out',
    onSelect: () => $iproKeycloak.logout(),
  }],
])
</script>

<template>
  <UDropdownMenu :items="items" :content="{ align: 'end' }" :ui="{ content: 'min-w-64' }">
    <UButton variant="ghost" trailing-icon="i-lucide-chevrons-up-down">
      <Text class="hidden md:inline">
        {{ $iproKeycloak?.tokenParsed?.preferred_username || 'Utilisateur' }}
      </Text>
    </UButton>
    <template #account>
      <div class="flex flex-col gap-1 p-2">
        <Text>{{ $iproKeycloak?.tokenParsed?.preferred_username || 'Utilisateur' }}</Text>
        <Text size="xs" class="text-gray-400">
          {{ $iproKeycloak?.tokenParsed?.email || 'Email non renseigné' }}
        </Text>
      </div>
    </template>
  </UDropdownMenu>
</template>
